import { render } from "./Tuiguang.vue?vue&type=template&id=cda805ba&scoped=true"
import script from "./Tuiguang.vue?vue&type=script&lang=js"
export * from "./Tuiguang.vue?vue&type=script&lang=js"

import "./Tuiguang.vue?vue&type=style&index=0&id=cda805ba&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda805ba"]])

export default __exports__